<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      Trả Hàng
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csReturns" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row v-if="receipt">
            <b-col sm="6" xs="12">
              <base-input v-model="receipt.code" readonly label="Mã phiếu xuất"></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input v-model="receipt.customer.name" readonly label="Đơn vị đặt hàng"></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input v-model="row.order.code" readonly label="Mã đơn hàng"></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input v-model="row.productInfo.product.code" readonly label="Mã sản phẩm"></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input v-model="row.productInfo.product.name" readonly label="Tên sản phẩm"></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input v-model="row.productInfo.productSpecify.name" readonly label="Quy cách"></base-input>
            </b-col>
            <b-col sm="4" xs="12">
              <base-input v-model="row.productInfo.colorText" readonly label="Màu sắc"></base-input>
            </b-col>
            <b-col sm="4" xs="12">
              <base-input v-model="row.productInfo.colorCode1" readonly label="Mã màu 1"></base-input>
            </b-col>
            <b-col sm="4" xs="12">
              <base-input v-model="row.productInfo.unit" readonly label="ĐVT"></base-input>
            </b-col>
            <b-col sm="12" xs="12">
              <ValidationProvider name="Số lượng hàng trả" rules="required" v-slot="{ errors }">
                <base-input
                  label="Số lượng hàng trả"
                  :error="errors[0]"
                  v-model="row.quantity"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col sm="12" xs="12">
              <b-textarea placeholder="Lý do trả hàng" v-model="row.note" rows="4"></b-textarea>
            </b-col>
          </b-row>
        </form>
        <hr />
        <b-row align-h="center">
          <b-col sm="6" xs="12" md="4">
            <b-button class="mb-2" type="submit" block variant="success" @click="doSave(0)">
              Lưu đóng (F4)
            </b-button>
          </b-col>
          <b-col sm="12" md="4">
            <b-button class="mb-2" block variant="secondary" @click="handleClose">
              Đóng (Esc)
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </block>
    <event @doCancel="handleClose" @doSave="doSave(0)" @doSaveContinue="doSave(1)"></event>
  </modal>
</template>
<script>
import { receiptService } from '@/_services';
export default {
  props: {},
  data() {
    return {
      visible: false,
      receipt: {
        customer: {}
      },
      row: {
        order: {},
        productInfo: {
          product: {},
          productSpecify: {}
        }
      }
    };
  },
  methods: {
    doSave: function() {
      var self = this;
      if (!this.visible) return;
      this.$refs.csReturns.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();

        let receipt = Object.assign({}, self.receipt);
        receipt.ReceiptBillDetails = [];

        receiptService
          .createReturn(receipt, self.row)
          .then(res => {
            //self.ownInfo.name = self.info.name;
            self.visible = false;
            self.$alertify.success(res.message, {
              duration: 4000
            });
            this.$emit('change');
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csReturns.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bmdal.unBlock();
          });
      });
    },
    setData(receipt, row) {
      debugger;
      this.receipt = receipt;
      row.note = '';
      let receiptBillReturn = row.receiptBillReturn;
      let countReturnQuantity = 0;
      if (receiptBillReturn) {
        for (let i = 0; i < receiptBillReturn.length; i++) {
          const element = receiptBillReturn[i];
          countReturnQuantity += element.quantity;
        }
      }
      this.row = Object.assign({}, row);
      this.row.quantity = this.row.quantity - countReturnQuantity;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss"></style>
